import PropTypes from 'prop-types';
import React from 'react';

import useGroup from '../../hooks/use_group';
import useProduct from '../../hooks/use_product';
import useQueryParameters from '../../hooks/use_query_parameters';
import useSiteMetadata from '../../hooks/use_site_metadata';
import useTranslation from '../../hooks/use_translation';
import GroupLink from '../framework/group_link';
import Link from '../framework/link';

const ProductGroupList = ({ activeId, exclude_groups }) => {
	const { queryParameters } = useQueryParameters();
	let siteMetadata = useSiteMetadata();
	const { t } = useTranslation('component_product_group_list');
	const { items: groups } = useGroup({
		exclude_groups,
	});
	const { items: products } = useProduct({ has_markers: true });

	return (
		<div className="position-relative">
			<nav className="px-0 container">
				<GroupLink
					className={`grid-list-groups-item  ${!activeId ? 'active' : ''}`}
					page="tester"
					query_parameters={queryParameters}
				>
					{t('t1')} {`(${products.length})`}
				</GroupLink>
				{siteMetadata?.config?.campaigns && (
					<Link className={`grid-list-groups-item x-small`} to="/kampanjer/">
						{t('t2')}
					</Link>
				)}
				{groups.map((group, index1) => {
					const products_filtered = products.filter((product) => {
						return product.groups.includes(group.group_id);
					});
					if (!products_filtered || !products_filtered.length) return null;
					const isActive = activeId === group.group_id;

					return (
						<GroupLink
							className={`grid-list-groups-item  ${isActive ? 'active' : ''}`}
							groups={[group.group_id]}
							key={index1}
							page="tester"
							query_parameters={queryParameters}
						>
							{group.group_variant.title} {`(${products_filtered.length})`}
						</GroupLink>
					);
				})}
			</nav>
		</div>
	);
};

ProductGroupList.propTypes = {
	activeId: PropTypes.number,
	exclude_groups: PropTypes.array,
};

export default ProductGroupList;
